import Constants from "expo-constants";
import * as manifest from '../app.json';

export default Object.assign({}, Constants, {
  manifest: manifest.expo
});